import { Link } from "react-router-dom";

import "./MyStyles.css";

function Menu() {
  const userGroup = localStorage.getItem("userGroup");

  return (
    <section>
      <div className="row">

        {/* ================= ADMIN ================= */}
        {userGroup === "Admin" && (
          <>
            <MenuCard to="/admin" icon="fa-solid fa-chart-line" title="Dashboard" />
            <MenuCard to="/news" icon="fa fa-newspaper" title="News" />
            <MenuCard to="/todo" icon="fa fa-list" title="To Do" />
            <MenuCard to="/admin/users" icon="fa fa-users" title="Users" />
            <MenuCard to="/admin/products" icon="fa fa-boxes" title="Products" />
            <MenuCard to="/admin/orders" icon="fa fa-shopping-cart" title="Orders" />
          </>
        )}

        {/* ================= SELLER ================= */}
        {userGroup === "Seller" && (
          <>
            <MenuCard to="/seller" icon="fa-solid fa-chart-line" title="Dashboard" />
            <MenuCard to="/seller/add-category" icon="fa fa-tags" title="Add Category" />
            <MenuCard to="/seller/add-product" icon="fa fa-box" title="Add Product" />
            <MenuCard to="/seller/products" icon="fa fa-boxes" title="My Products" />
            <MenuCard to="/seller/orders" icon="fa fa-shopping-cart" title="Orders" />
          </>
        )}

        {/* ================= CUSTOMER ================= */}
        {userGroup === "Customer" && (
          <>
            <MenuCard to="/" icon="fa-solid fa-home" title="Home" />
            <MenuCard to="/products" icon="fa fa-th" title="Products" />
            <MenuCard to="/cart" icon="fa fa-shopping-cart" title="Cart" />
            <MenuCard to="/wishlist" icon="fa fa-heart" title="Wishlist" />
            <MenuCard to="/orders" icon="fa fa-box" title="My Orders" />
            <MenuCard to="/compare" icon="fa fa-balance-scale" title="Compare" />
            <MenuCard to="/user/profile" icon="fa fa-user" title="Profile" />
            <MenuCard to="/user/change-password" icon="fa fa-key" title="Change Password" />
          </>
        )}

      </div>
    </section>
  );
}

/* ================= MenuCard Component ================= */
const MenuCard = ({ to, icon, title }) => (
  <div className="col-sm-2 me-4">
    <div className="card shadow mt-4" id="my-card">
      <div className="card-body text-center">
        <Link to={to}>
          <p className="fw-bold pt-2">{title}</p>
        </Link>
      </div>
    </div>
  </div>
);

export default Menu;
